import Big from "big.js";
import { type Address, erc20Abi, getAddress } from "viem";
import { useReadContract } from "wagmi";

export function useGetErc20Balance(tokenAddress: Address, currency: "USD" | "EUR", address?: string) {
    const { data: balance, refetch } = useReadContract({
        abi: erc20Abi,
        address: tokenAddress,
        functionName: "balanceOf",
        args: address != null ? [getAddress(address)] : undefined,
        account: address != null ? getAddress(address) : undefined,
    });

    const { data: decimals } = useReadContract({
        abi: erc20Abi,
        address: tokenAddress,
        functionName: "decimals",
    });

    if (balance == null || decimals == null) {
        return {};
    }

    return {
        balance,
        decimals,
        balanceString: Big(balance.toString()).div(Big(10).pow(decimals)).toString(),
        balanceFormatted: Big(balance.toString()).div(Big(10).pow(decimals)).toNumber().toLocaleString("en-US", {
            style: "currency",
            currency: currency,
        }),
        refetch,
    };
}
